import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { fetchBroadcasts } from './broadcasts-api'

export const BROADCASTS_PAGE_SIZE = 20

export const broadcastKeys = {
  all: ['admin-broadcasts'] as const,
  list: (page: number) => [...broadcastKeys.all, 'list', page] as const,
}

export const broadcastsPageQuery = (page: number) =>
  queryOptions({
    queryKey: broadcastKeys.list(page),
    queryFn: ({ signal }) =>
      fetchBroadcasts({ limit: BROADCASTS_PAGE_SIZE, offset: page * BROADCASTS_PAGE_SIZE }, signal),
    placeholderData: keepPreviousData,
  })
